export const QUICK_EDIT_PROFILE_FIELDS = [
  'clientFirstName',
  'clientLastName',
] as const;

export const QUICK_EDIT_PREDICTION_FIELDS = [
  'clientBirthDate',
  'clientZipCode',
  'clientLtcZipCode',
  'clientHasDifferentLtcZipCode',
  'clientGenderAtBirth',
  'clientRace',
  'clientHeightInches',
  'clientWeightPounds',
  'clientDisabilityWorkersComp',
  'householdTotalAssetsValue',
  'householdHouseholdSize',
  'householdLivingChildrenCount',
  'clientLivingSiblingsCount',
] as const;

export const QUICK_EDIT_ALL_FIELDS = [
  ...QUICK_EDIT_PROFILE_FIELDS,
  ...QUICK_EDIT_PREDICTION_FIELDS,
] as const;

export type QuickEditFieldName = (typeof QUICK_EDIT_ALL_FIELDS)[number];
